import React from "react";
import {useNavigate} from "react-router-dom";
import {IconButton, TooltipHost} from "@fluentui/react";
import PathConstants from "../../../../routes/pathConstants";
import {useSelector} from "react-redux";
import type {RootState} from "../../../../store";

const ConstructionNavigation: React.FC = () => {
  const {nextId, prevId} = useSelector((state: RootState) => state.constructionNew);
  return (
    <>
      <NavigationButton id={prevId} type={NavigationButtonType.Previous} />
      <NavigationButton id={nextId} type={NavigationButtonType.Next} />
    </>
  );
};

enum NavigationButtonType {
  Previous,
  Next,
}

interface NavigationButtonProps {
  id: string | null;
  type: NavigationButtonType;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({id, type}) => {
  const navigate = useNavigate();
  if (id === null) {
    return null;
  }
  const iconName = getIconName(type);
  const tooltipContent = "Go to next construction.";
  return (
        <TooltipHost content={tooltipContent}>
          <IconButton
            iconProps={{iconName}}
            onClick={() => {
              void navigate(`/${PathConstants.Constructions}/${id}`);
            }}
          />
        </TooltipHost>
  );
};

const getIconName = (type: NavigationButtonType): string => {
  switch (type) {
    case NavigationButtonType.Previous:
      return "ChevronLeftMed";
    case NavigationButtonType.Next:
      return "ChevronRightMed";
  }
};

export default ConstructionNavigation;
